import { useMemo } from 'react';

import type { StarterDashboardV2PageData } from 'src/app/pages/starterDashboardV2/pageContext';
import type {
	FullPostType,
	PostPreviewSizes,
	RecommendedGroup,
	RecommendedGroupPickerProps,
	SharingProps,
} from 'src/app/pages/starterDashboardV2/shared/components';
import type { useRecommendations } from 'src/app/pages/starterDashboardV2/shared/contexts';

type UseRenderPostPropsParams = {
	petition: StarterDashboardV2PageData['petition'];
	isMobile: boolean;
	recommendationsData: ReturnType<typeof useRecommendations>['data'];
	previewSize: PostPreviewSizes;
	startSharingFlow: (props: SharingProps) => void;
	startGroupSelection: (
		props: Omit<RecommendedGroupPickerProps, 'isOpen' | 'onGroupSelected' | 'onClose'>,
	) => Promise<RecommendedGroup | undefined>;
	trackClick: (fullPostType: FullPostType) => void;
	trackGroupSelection: (fullPostType: FullPostType) => void;
};

export function useRenderPostProps({
	petition,
	isMobile,
	recommendationsData,
	previewSize,
	startSharingFlow,
	startGroupSelection,
	trackClick,
	trackGroupSelection,
}: UseRenderPostPropsParams) {
	return useMemo(
		() => ({
			petition,
			isMobile,
			recommendationsData,
			options: {
				previewSize,
				startSharingFlow,
				startGroupSelection,
				trackClick,
				trackGroupSelection,
			},
		}),
		[
			petition,
			isMobile,
			recommendationsData,
			previewSize,
			startSharingFlow,
			startGroupSelection,
			trackClick,
			trackGroupSelection,
		],
	);
}
